import { retry, RetryError } from 'ts-retry-promise';
import type { RetryConfig } from 'ts-retry-promise';
import { canRetryQuery, MAX_RETRY_COUNT } from '@bimone/bimtrack-core';
import HttpError from 'standard-http-error';

export default function executeWithRetry<TResult>(
  task: () => Promise<TResult>,
  options?: Partial<RetryConfig<TResult>>
): Promise<TResult> {
  return retry(task, {
    delay: 1000,
    backoff: 'EXPONENTIAL',
    retries: MAX_RETRY_COUNT,
    timeout: 'INFINITELY',
    retryIf: (error: unknown) => canRetryQuery([HttpError.TOO_MANY_REQUESTS])(0, error),
    ...options,
  }).catch((error: RetryError) => {
    throw error.lastError;
  });
}
